import styled from '@emotion/styled';
import Article from '../Skills/Article';

const Project = styled(Article)`
  text-align: left;
  //min-height: 460px;
`;

export default Project;
